import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import { NavigatorIndicator, NavigatorLine, NavigatorMenu } from './navigator';
import { setProgress } from '../../reducers/wizard';
import './wizard.css';

class Wizard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeStep: undefined,
            controlled: false,
            steps: undefined
        };

        this.setActiveStep = this.setActiveStep.bind(this);
        this.backward = this.backward.bind(this);
        this.forward = this.forward.bind(this);

        this.getValidStep = this.getValidStep.bind(this);
    }

    backward() {
        let to = this.state.activeStep - 1;
        if (to >= 0) {
            this.setState({ ...this.state, activeStep: to, controlled: true }, () => window.scrollTo(0, 0));
        }
    }

    forward(to, entityId = undefined, branch = 'default', onSuccess = () => null) {
        const { configuration, progress, setProgress, getSteps } = this.props;
        let steps = getSteps({ back: this.backward, next: this.forward }, { step: to, branch });
        this.setState(
            {
                ...this.state,
                activeStep: to,
                controlled: true,
                steps
            },
            () => {
                if (progress.step < to || progress.branch !== branch) {
                    setProgress({ ...configuration, id: entityId }, { ...progress, step: to, branch: branch }, () => {
                        if (onSuccess && typeof onSuccess === 'function') {
                            onSuccess();
                        }
                        window.scrollTo(0, 0);
                    });
                }
            }
        );
    }

    setActiveStep(step, controlled = undefined) {
        if (step === this.state.activeStep) {
            return;
        }

        this.setState({
            ...this.state,
            activeStep: step,
            controlled: controlled !== undefined ? controlled : this.state.controlled
        });
    }

    componentDidMount() {
        const { configuration, getSteps, setProgress } = this.props;
        if (!configuration.id) {
            setProgress(configuration, { step: 0, branch: 'default' }, progress => {
                let steps = getSteps({ back: this.backward, next: this.forward }, progress);
                let activeStep = this.getValidStep(steps, progress);

                this.setState({
                    ...this.state,
                    activeStep,
                    steps
                });
            });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { activeStep } = this.state;
        const { progress, getSteps } = nextProps;
        if (!activeStep && progress) {
            let steps = getSteps({ back: this.backward, next: this.forward }, progress);
            let activeStep = this.getValidStep(steps, progress);

            this.setState({
                ...this.state,
                activeStep,
                steps
            });
        }
    }

    getValidStep(steps, progress) {
        let count = steps.length;
        let step = progress.step;

        if (step < 0) {
            return 0;
        }

        if (step >= count) {
            return count - 1;
        }

        return step;
    }

    render() {
        const { activeStep, steps } = this.state;
        const { navigatorClickable, progress } = this.props;

        if (!progress) {
            return null;
        }

        if (!steps || steps.lenght === 0 || activeStep === undefined) {
            return null;
        }

        return (
            <div className="page wizard">
                <NavigatorMenu
                    steps={steps}
                    navigatorClickable={navigatorClickable}
                    onStepClick={s => this.setActiveStep(s, true)}
                    activeStep={activeStep}
                    progress={progress.step}
                />
                <div className="row">
                    {steps[activeStep].props.headerImage && (
                        <div className="intro-image" style={{ backgroundImage: `url(${steps[activeStep].props.headerImage})` }} />
                    )}

                    {!steps[activeStep].props.hideTitle && (
                        <div className="col-xs-12 col-sm-10 wizard-page-title">
                            <h3>{steps[activeStep].props.title || <FormattedMessage {...steps[activeStep].props.message} />}</h3>
                        </div>
                    )}
                    {!steps[activeStep].props.hideMenu && (
                        <div className="col-xs-2 text-right hidden-xs">
                            <NavigatorIndicator steps={steps} activeStep={this.state.activeStep} />
                        </div>
                    )}

                    {!steps[activeStep].props.hideProgress && (
                        <div className="col-xs-12">
                            <NavigatorLine steps={steps} activeStep={this.state.activeStep} progress={progress.step} />
                        </div>
                    )}

                    <div className="col-xs-12">{steps[activeStep]}</div>
                </div>
            </div>
        );
    }
}

Wizard.defaultProps = {
    getSteps: undefined,
    configuration: undefined,
    navigatorClickable: true
};

Wizard.propTypes = {
    getSteps: PropTypes.func.isRequired,
    configuration: PropTypes.shape({
        id: PropTypes.string,
        entity: PropTypes.string
    }).isRequired,
    navigatorClickable: PropTypes.bool
};

const mapStateToProps = state => ({
    menuActive: state.wizard.menuActive,
    progress: state.wizard.progress
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            setProgress: setProgress
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(Wizard);



// WEBPACK FOOTER //
// ./src/components/wizard/index.jsx